// Same encoder react-qr-code renders with, so the module count here matches the printed symbol.
import QRCodeModel from 'qr.js/lib/QRCode';
import ErrorCorrectLevel from 'qr.js/lib/ErrorCorrectLevel';

class QrCodeHelpers {
  static moduleCount(value, level = 'L') {
    const qrcode = new QRCodeModel(-1, ErrorCorrectLevel[level]);
    qrcode.addData(value);
    qrcode.make();

    return qrcode.getModuleCount();
  }

  /**
   * Largest size up to `maxSize` that gives every module a whole number of pixels. The receipt
   * is rasterized at 1px per printer dot, and a fractional module gets anti-aliased into grey
   * edges that the thermal head then dithers, which leaves the code unscannable.
   */
  static pixelAlignedSize(value, maxSize, level = 'L') {
    const modules = QrCodeHelpers.moduleCount(value, level);

    return Math.max(1, Math.floor(maxSize / modules)) * modules;
  }
}

export default QrCodeHelpers;
